var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15428 7.93453L0.278806 12.3625C-0.0490409 12.7371 -0.0490409 13.3445 0.278806 13.7191C0.606654 14.0936 1.1382 14.0936 1.46605 13.7191L6.75411 7.67705C7.08196 7.30246 7.08196 6.69513 6.75411 6.32054C6.73243 6.29578 6.70987 6.27264 6.68652 6.25115C6.65287 6.21772 6.61685 6.1873 6.57881 6.16026L1.43313 0.280942C1.10528 -0.093647 0.573733 -0.0936478 0.245886 0.280942C-0.0819619 0.655531 -0.0819619 1.26286 0.245886 1.63745L4.07819 6.01614L4.84888 7.01412L4.15428 7.93453Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.7001948f7d0d07159073c4fd1bef87ff.svg";
export { ForwardRef as ReactComponent };